import {
  primaryColor,
  defaultFont,
} from '../../styles/style';

const style = {
  formControl: {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'start',
  },
  formControl_noMargin: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'start',
    margin: 0,
  },
  formControl_oneLine: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 0,
  },
  formControl_force2fa: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 0,
    position: 'relative',
    bottom: '6px',
  },
  formControl_sso: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'start',
    margin: 0,
  },
  formControl_oneLineReversedLeftAligned: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 0,
    width: 'fit-content',
  },
  switch__label: {
    ...defaultFont,
    color: '#AAAAAA',
    // fontWeight: '400',
    fontSize: '11px',
    lineHeight: '1.42857',
    transition: '0.3s ease all',
    paddingLeft: '14px',
  },
  switch__label_oneLine: {
    color: primaryColor,
    fontSize: '14px',
  },
  switch__label_noPadding: {
    color: primaryColor,
    fontSize: '14px',
    padding: 0,
  },
  switch__label_policySettings: {
    ...defaultFont,
    color: '#AAAAAA',
    fontSize: '11px',
    lineHeight: '1.42857',
    transition: '0.3s ease all',
    paddingLeft: 0,
  },
  switch__label_sso: {
    paddingLeft: 0,
  },
  switch_td: {
    height: 0,
  },
  root: {
    width: 40,
    height: 24,
    padding: 0,
    overflow: 'visible',
    margin: 8,
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#ffffff',
      '& + $track': {
        backgroundColor: '#4caf50',
        border: '2px solid #4caf50',
        opacity: 1,
      },
      '&$disabled': {
        color: '#9e9e9e',
        '& + $track': {
          backgroundColor: '#7cd67f',
          border: '2px solid #7cd67f',
          opacity: 0.75,
        },
      },
    },
    '&$disabled': {
      color: '#9e9e9e',
      '& + $track': {
        backgroundColor: '#ccc',
        border: '2px solid #ccc',
        opacity: 0.75,
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: 'none',
    backgroundColor: '#ffffff',
    opacity: 1,
  },
  track: {
    borderRadius: 12,
    backgroundColor: '#cccccc',
    border: '2px solid #cccccc',
    opacity: 1,
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxSizing: 'border-box',
    height: 24,
    width: 40,
  },
  checked: {},
  disabled: {},
};

export default style;
